import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { serverResponse } from "../../util/fakeServer";
import { language } from "../../languageProvider/language/language";
import { defaultLanguage } from "../../helper/utility";
import "./AccountSidebar.css";

const allTabs = [
  {
    key: "profilo",
    labelKey: "profilo",
    path: "/profilo",
    configFlag: "show_profile_tab",
    defaultVisible: true,
  },
  {
    key: "ordini",
    labelKey: "ordini",
    path: "/profilo/ordini",
    configFlag: "show_orders_tab",
    defaultVisible: false,
  },
  {
    key: "preferiti",
    labelKey: "preferiti",
    path: "/profilo/preferiti",
    configFlag: "show_favorites_tab",
    defaultVisible: false,
  },
  {
    key: "premi",
    labelKey: "premi",
    path: "/profilo/premi",
    configFlag: "show_prizes_tab",
    defaultVisible: false,
  },
  {
    key: "assistenza",
    labelKey: "assistenza",
    path: "/profilo/assistenza",
    configFlag: "show_support_tab",
    defaultVisible: false,
  },
];

const AccountSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // I 5 tab non sono ancora pilotabili dai flag show_*_tab del publication.json:
  // per ora, con allow_login attivo, mostriamo SOLO "Profilo" e "Ordini".
  // Preferiti / Premi / Assistenza restano per sviluppo futuro (riattivabili poi
  // ripristinando il filtro su tab.configFlag / tab.defaultVisible).
  const allowLogin = serverResponse.config.allow_login;
  const enabledKeys = ["profilo", "ordini"];
  const visibleTabs = allTabs.filter(
    (tab) => allowLogin && enabledKeys.includes(tab.key)
  );

  const isActive = (tabPath) => {
    if (tabPath === "/profilo") {
      return location.pathname === "/profilo";
    }
    return location.pathname.startsWith(tabPath);
  };

  return (
    <div className="acc-sidebar">
      <nav className="acc-sidebar__nav">
        {visibleTabs.map((tab) => {
          const active = isActive(tab.path);
          return (
            <div
              key={tab.key}
              className={`acc-sidebar__item ${active ? "acc-sidebar__item--active" : ""}`}
              onClick={() => navigate(tab.path)}
            >
              {language[defaultLanguage][tab.labelKey]}
            </div>
          );
        })}
      </nav>
    </div>
  );
};

export default AccountSidebar;
